<div class="iframe-container">
    <iframe id="myIframe" [src]="cartoIframeUrl" frameborder="0" height="100%" width="100%"></iframe>
</div>  